import { audioType } from 'holdem/interfaces'
import { useEffect } from 'react'
import useSound from 'use-sound'
import BackgroundSFX from '../../lib/assets/audio/backgroundSFX.mp3'

export const handleBackgroundSFX = (
  audio: audioType,
  errorText: string | false,
  showLoader: boolean,
) => {
  const { volume, music } = audio
  const [playBackgroundSFX, { stop, sound }] = useSound(BackgroundSFX, {
    volume: parseFloat(volume),
  })

  useEffect(() => {
    music && errorText === false && !showLoader
      ? (() => {
          playBackgroundSFX()
          sound && sound.loop(true)
        })()
      : stop()
  }, [music, playBackgroundSFX, stop, sound, errorText, showLoader])
}
